import React from 'react';
import TransformSection from './common/transform-section';
import { registerInspector } from './inspector-registry';
import AppearanceSection from './shared/appearance-section';
import FillGradientSection from './shared/fill-gradient-section';
import SlotFilterSection from './shared/slot-filter-section';
import VisibleWhenSection from './shared/visible-when-section';
import { useFillGradient } from './shared/use-fill-gradient';
import type { ObjectInspectorProps } from './types';

/**
 * Inspector for the fillable shapes that carry no type-specific geometry controls —
 * circle, ellipse, triangle and every polygon the Shapes menu builds (right
 * triangle, pentagon, hexagon, star, diamond, all `type: 'polygon'`). They share one
 * component because their inspectable surface is identical; `rect` keeps its own
 * because of the per-corner radius section. Before this they fell through to
 * FallbackInspector and had no fill controls at all.
 */
const ShapeInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const gradient = useFillGradient(objects, editor);

  return (
    <>
      <TransformSection objects={objects} editor={editor} />
      <AppearanceSection objects={objects} editor={editor} gradient={gradient} />
      <FillGradientSection control={gradient} />
      <SlotFilterSection objects={objects} editor={editor} />
      <VisibleWhenSection objects={objects} editor={editor} />
    </>
  );
};

export default ShapeInspector;

registerInspector('circle', ShapeInspector);
registerInspector('ellipse', ShapeInspector);
registerInspector('triangle', ShapeInspector);
registerInspector('polygon', ShapeInspector);
